<template>
    <div class="search_container" :class="{ end: !showBack }">
        <el-button v-if="showBack" class="def_btn" size="small" icon="el-icon-arrow-left" @click="backTo">返回</el-button>
        <div class="search_top" v-if="loadSearch">
            <el-input clearable :placeholder="placeholder" v-model="searchKWord" class="input-with-select" size="small"
                @change="search">
                <el-select v-model="searchType" slot="prepend" placeholder="请选择" :popper-append-to-body="false"
                    @change="changeType">
                    <el-option v-for="item in typeList" :key="(item.label + '_' + item.value)" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
                <el-button type="primary" slot="append" @click="search">搜索</el-button>
            </el-input>
        </div>
    </div>
</template>

<script>
import { setDatas } from '@/api/portrait.js'
export default {
    props: {
        inputParam: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            searchKWord: '',
            searchType: '1',
            placeholder: '输入名称或岗位进行搜索',
            typeList: [
                { label: '服务人员', value: '1' },
                { label: '终端', value: '2' },
                { label: '渠道', value: '3' },
            ]
        };
    },
    created() {
        if (this.$route.path.indexOf('salesmanDetail') > -1 || this.$route.path.indexOf('portraitDetail') > -1) {
            return
        }

        if (sessionStorage.getItem('childDatas')) {
            let datas = setDatas('searchKey')
            Object.assign(this.$data, datas);
        } else {
            this.search()
        }
    },
    computed: {
        loadSearch() {
            return this.$route.path.indexOf('salesmanList') > -1 || this.$route.path.indexOf('portraitSalesman') > -1
        },
        showBack() {
            return (this.$route.path.indexOf('salesmanDetail') > -1 || this.$route.path.indexOf('portraitDetail') > -1) && sessionStorage.getItem('showBack') == 'true'
        }
    },
    mounted() {
        // this.renderList()
    },
    methods: {
        changeCity(row) {
            this.filterRule[1].options = row.children
        },
        changeType(val) {
            this.placeholder = val == '1' ? '输入名称或岗位进行搜索' : '输入名称或关键字进行搜索'
            this.$emit('setParam', null, false, this.searchType)
        },
        backTo() {
            // let queryInfo = this.$route.query.pageMenuGuid
            if (this.$route.path.indexOf('relativeNetwork') > -1) {
                // this.$router.push({ path: '/portrait/portraitHome', query: { pageMenuGuid: queryInfo } })
            } else {
                //   this.$router.push({path: '/portrait/salesmanList', query: {pageMenuGuid: queryInfo}})
                // this.$router.back()
            }
            this.$router.back()
        },
        search() {
            let param = {
                keyword: this.searchKWord
            }
            this.$emit('setParam', param, true, this.searchType)
        },
    },
};
</script>
<style lang="less" scoped>
.search_container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.end {
        justify-content: flex-end;
    }

    /deep/.el-input-group__prepend {
        width: 60px;
        font-size: 12px;
        background: #4FA1A4;
        border-radius: 2px;
        color: #fff;

        .el-select .el-input .el-select__caret {
            color: #fff;
        }

        .el-input-group--prepend .el-input__inner {
            width: 245px;
            font-size: 12px;
            border-radius: 2px;
            border-color: #d9d9d9;
            color: #b2b2b2;
        }
    }

    /deep/.el-input-group__append {
        font-size: 12px;
        padding: 0 16px;
        background: #4FA1A4;
        border-radius: 2px;
        color: #fff;
        left: 10px;
    }
}

/deep/.el-popper.el-select-dropdown {
    .el-select-dropdown__item {
        font-size: 12px !important;
        font-weight: normal !important;
    }

    .el-select-dropdown__item.selected {
        color: #4FA1A4 !important;
        font-weight: 600 !important;
    }
}
</style>
